/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScanMetadata = {
    /**
     * Type of scanner
     */
    scannerType: ScanMetadata.scannerType;
    /**
     * Mode of scan
     */
    scanMode: string;
    /**
     * Part of the body that was scanned
     */
    bodyPart: string;
    /**
     * The side of the body part that was scanned
     */
    side: string;
    /**
     * The product to be produced
     */
    product: string;
    /**
     * encoding of the 3D scan data
     */
    encoding: string;
    /**
     * whether it's a left or right foot
     */
    foot: string;
    /**
     * serial number of the 3D scanner
     */
    serial: string;
    /**
     * firmware version of the 3D scanner
     */
    firmware: string;
    /**
     * Software with which the scan was made, e.g. rs scan agent 2.0.24
     */
    origin: string;
    /**
     * Date and time of scan.
     */
    timestamp: string;
};
export namespace ScanMetadata {
    /**
     * Type of scanner
     */
    export enum scannerType {
        MOCK_SCANNER = 'MOCK_SCANNER',
        TIGER = 'TIGER',
        I_QUBE_E303 = 'iQUBE_E303',
        UNKNOWN_DEVICE_MODEL = 'UNKNOWN_DEVICE_MODEL',
        INVALID_DEVICE_MODEL = 'INVALID_DEVICE_MODEL',
        OCCIPITAL_ST02A = 'OCCIPITAL_ST02A',
        OCCIPITAL_ST02B = 'OCCIPITAL_ST02B',
        TRUEDEPTH = 'TRUEDEPTH',
    }
}

